document.addEventListener('DOMContentLoaded', () => {
    let progressAnimationStarted = false;

    const toggleProgressAnimation = () => {
        const progressBarTitle = document.querySelector('.progress_bar_title');
        const progressBarTitleRect = progressBarTitle.getBoundingClientRect();

        // Check if the progress_bar_title is in the viewport
        const isInViewport = progressBarTitleRect.top >= 0 && progressBarTitleRect.bottom <= window.innerHeight;

        if (isInViewport && !progressAnimationStarted) {
            startProgressAnimation();
            progressAnimationStarted = true;
        }
    };

    const startProgressAnimation = () => {
        // Your existing code for the progress bar animations
        const speed = 20;
        const item = document.querySelector('#myBar2');
        const stripedItem = document.querySelector('.striped-progress-bar');
        const progressHeading = document.querySelector('.progress_heading');
        let headingValue = parseInt(progressHeading.textContent);
        const itemValue = parseInt(item.getAttribute('progress-percent'));
        const stripedValue = parseInt(stripedItem.getAttribute('striped-progress-percent'));
        let i = 0;
        let j = 0;

        // Function to animate the main progress bar
        const animateMainProgressBar = () => {
            if (i <= itemValue) {
                item.style.width = i + '%';
                item.setAttribute('progress-percent', i.toString());
                i++;
            } else {
                clearInterval(mainProgressInterval);
            }
        };

        function updateHeading(value) {
            progressHeading.textContent = `${value.toString()}x`;
        }

        for (let i = headingValue; i <= 40; i++) {
            setTimeout(() => updateHeading(i), i * 50);
        }

        // Function to animate the striped progress bar
        const animateStripedProgressBar = () => {
            if (j <= stripedValue) {
                stripedItem.style.width = j + 'px';
                stripedItem.setAttribute('striped-progress-percent', j.toString());
                j++;
            } else {
                clearInterval(stripedProgressInterval);
            }
        };

        // Start the main progress bar animation
        const mainProgressInterval = setInterval(animateMainProgressBar, speed);

        // Start the striped progress bar animation
        const stripedProgressInterval = setInterval(animateStripedProgressBar, speed);
    };

    // Attach the toggleProgressAnimation function directly to the scroll event
    window.addEventListener('scroll', toggleProgressAnimation);

    // Initial check on page load
    toggleProgressAnimation();
});